import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Error from '@material-ui/icons/Error';
var useStyles = makeStyles(function () {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: '100%',
      justifyContent: 'center',
      alignItems: 'center'
    }
  };
});
var NO_RESULT_MESSAGE_ID = 'noResultMessage';
var NoData = function NoData(_ref) {
  var icon = _ref.icon,
    message = _ref.message;
  var classes = useStyles();
  return React.createElement('div', {
    className: classes.root
  }, React.createElement(Typography, {
    variant: 'subtitle1',
    noWrap: true,
    align: 'center'
  }, icon || React.createElement(Error, {
    color: 'primary',
    fontSize: 'large'
  })), React.createElement(Typography, {
    variant: 'subtitle1',
    noWrap: true,
    align: 'center',
    tabIndex: '0',
    id: NO_RESULT_MESSAGE_ID
  }, message));
};
NoData.propTypes = process.env.NODE_ENV !== "production" ? {
  icon: PropTypes.element,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
} : {};
export default NoData;